import { render } from "./ApprovedList.vue?vue&type=template&id=6e476af6"
import script from "./ApprovedList.vue?vue&type=script&lang=js"
export * from "./ApprovedList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__